import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { showRoleReassign } from '../actions';
import ReassignAction from '../components/ReassignAction';

const ReassignUsersAction = ({ users, roleReassign }) => (
  <ReassignAction roleReassign={roleReassign} users={users} disabled={users.length === 0} />
);

const mapStateToProps = ({
  auth: { users },
}, { category }) => ({
  users: findSelectedInCategory(users, category),
});

const mapDispatchToProps = {
  roleReassign: showRoleReassign,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReassignUsersAction);
